import * as z from "zod/v4";

export const getNetSuiteOAuthUrl = {
  name: "getNetSuiteOAuthUrl" as const,
  input: z.object({}),
  output: z.object({ authUrl: z.string() }),
};
